import React, { useState, useEffect } from 'react';
import './css/TypingText.css'; // Add your custom styles here

const sentences = [
    'Kaderníctvo',
    'Opravár',
    'Masáž',
    'Kozmetička',
    'Manikúra',
];


function TypingText() {
    const [currentSentenceIndex, setCurrentSentenceIndex] = useState(0);
    const [displayedText, setDisplayedText] = useState("");
    const [isDeleting, setIsDeleting] = useState(false);
    const [typingSpeed, setTypingSpeed] = useState(150); // Speed for typing animation
    const [isPaused, setIsPaused] = useState(false); // New state to handle pauses

    useEffect(() => {
        const currentSentence = sentences[currentSentenceIndex];

        const handleTyping = () => {
            if (isPaused) return; // Exit if paused

            if (!isDeleting) {
                // Typing characters
                setDisplayedText((prev) => currentSentence.slice(0, prev.length + 1));

                // Once sentence is typed, wait before deleting
                if (displayedText.length + 1 === currentSentence.length) {
                    setIsPaused(true); // Pause after completing the sentence
                    setTimeout(() => {
                        setIsDeleting(true);
                        setIsPaused(false); // Resume after pause
                    }, 2000); // Pause duration before deletion starts
                } else {
                    setTypingSpeed(150); // Regular typing speed
                }
            } else {
                // Deleting characters
                setDisplayedText((prev) => currentSentence.slice(0, prev.length - 1));

                // Move to the next sentence after deleting
                if (displayedText.length === 1) { // Changed condition to wait until the last character is deleted
                    setIsDeleting(false);
                    setCurrentSentenceIndex((prev) => (prev + 1) % sentences.length);
                    setIsPaused(true); // Pause before starting to type the next sentence
                    setTimeout(() => {
                        setDisplayedText(""); // Clear displayed text
                        setIsPaused(false); // Resume after pause
                    }, 1000); // Pause duration before starting the next sentence
                } else {
                    setTypingSpeed(50); // Faster deleting speed
                }
            }
        };

        const timer = setTimeout(handleTyping, typingSpeed);

        return () => clearTimeout(timer);
    }, [displayedText, isDeleting, typingSpeed, currentSentenceIndex, isPaused]);

    return (
        <div className="typing-container">
            <span className="typed-text">{displayedText}</span>
            <span className="cursor">|</span>
        </div>
    );
}

export default TypingText;
